<div class="topbar" [ngClass]="{ 'theme-dark': isDarkMode() }">
  <div class="search-section">
    <mat-form-field class="search-bar" appearance="outline">
      <mat-label>Vessel Name</mat-label>
      <input matInput [(ngModel)]="searchTerm" (input)="inputSearch()" />
      <mat-icon matSuffix *ngIf="searchTerm" style="cursor: pointer; margin-top: 3px;" (click)="clearSearch()" class="close-icon">close</mat-icon>

    </mat-form-field>
  </div>
  <button mat-raised-button color="primary" class="add-button" (click)="openAddVesselDialog()">
    Add Vessel
  </button>
</div>

<div *ngIf="dataSource?.data as data">
  <ng-container *ngIf="data.length > 0; else noData">
    <div class="table-container" (scroll)="onManualScroll()">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [ngClass]="{ 'dark-table': isDarkMode() }">
        <ng-container matColumnDef="Sl.No">
          <th mat-header-cell *matHeaderCellDef> Sl.No </th>
          <td mat-cell *matCellDef="let i=index" style="text-align: center;"> {{i+1}}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef style="width: 150px;">Vessel Name </th>
          <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.name}} </td>
        </ng-container>

        <ng-container matColumnDef="grt">
          <th mat-header-cell *matHeaderCellDef> GRT </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.grt}} </td>
        </ng-container>

        <ng-container matColumnDef="rgrt">
          <th mat-header-cell *matHeaderCellDef> RGRT </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.rgrt}} </td>
        </ng-container>
        <ng-container matColumnDef="nrt">
          <th mat-header-cell *matHeaderCellDef> NRT </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.nrt}} </td>
        </ng-container>
        <ng-container matColumnDef="loa">
          <th mat-header-cell *matHeaderCellDef>LOA </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.loa}} </td>
        </ng-container>
        <ng-container matColumnDef="beam">
          <th mat-header-cell *matHeaderCellDef>Beam(Mrts) </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.beam}} </td>
        </ng-container>
        <ng-container matColumnDef="depth">
          <th mat-header-cell *matHeaderCellDef> Depth(Mrts) </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.depth}} </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type of Vessel </th>
          <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="imo_number">
          <th mat-header-cell *matHeaderCellDef>IMO Number </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.imo_number}} </td>
        </ng-container>
        <ng-container matColumnDef="dwt">
          <th mat-header-cell *matHeaderCellDef> Dead weight </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.dwt}} </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element" style="text-align: left;"> {{element.email}} </td>
        </ng-container>
        <!-- <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> status </th>
     
       <td mat-cell *matCellDef="let element"> <span [ngClass]="element.status === 'Active' ? 'status-active' : 'status-inactive'" >{{element.status}} </span> </td>
   
        </ng-container> -->
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element">
            <button class="edit-icon-button" mat-icon-button (click)="openEditVesselDialog(element)">
              <mat-icon>edit</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- <mat-paginator
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator> -->
  </ng-container>
</div>

<ng-template #noData>
  <div class="no-data-text">
    No data found.
  </div>
</ng-template>